/** @format */

import axios from 'axios';
import store from 'src/store/configureStore';
import { push } from 'connected-react-router';
import { getLoginInfo } from 'src/ui/features/Messaging/state/messagingReselect';
import { loginFailure } from 'src/ui/features/Login/state/loginActions';
import * as messagingTypes from 'src/ui/features/Messaging/state/messagingTypes';
import { LOGIN_URL } from 'src/constants/constants';
import intl from 'react-intl-universal';

// we'll settle up on where this should come out of in the future
// localStorage or some persistent redux store

function axiosRequest(method = 'get', url, data, config, errorAction, headerParams, ignoreErrorInterceptor = false) {
  const { token } = getLoginInfo(store.getState());

  // redirect unauthhorized user to login page
  if (!token) {
    return store.dispatch(push(LOGIN_URL));
  }

  const isFormDataPayload = typeof FormData !== 'undefined' && data instanceof FormData;

  const axiosConfig = {
    url,
    method: method.toLowerCase(),
    timeout: 180000,
    //  withCredentials: true,
    headers: {
      ...(isFormDataPayload ? {} : { 'Content-Type': 'application/json' }),
      'X-Content-Type-Options': 'nosniff',
      'Access-Control-Allow-Origin': '*',
      Token: token,
    },
    data: method === 'post' ? data : null,
    params: method === 'get' || method === 'delete' ? data : {},
    ...config,
  };

  if (headerParams) {
    axiosConfig.headers = Object.assign(axiosConfig.headers, headerParams);
  }

  return axios(axiosConfig)
    .then(res => {
      axiosConfig.headers = {
        ...axiosConfig.headers,
        'Access-Control-Allow-Origin': '*',
      };

      const { data } = res;

      if (data.success !== undefined && data.success === false && data.error && !ignoreErrorInterceptor) {
        const { code: errorCode } = data.error;
        if ((errorCode && parseInt(errorCode, 10) === 401) || parseInt(errorCode, 10) === 403) {
          store.dispatch(
            loginFailure({
              error: { message: intl.get('global.errors.invalidToken') },
            }),
          );
          store.dispatch(push(LOGIN_URL));
          return { messages: {} };
        }
      }

      return data;
    })
    .catch(error => {
      if (!ignoreErrorInterceptor) {
        if (error && !error.response) {
          if (error.error && error.error.code === '403') {
            return store.dispatch({ type: messagingTypes.CHECK_STATUS });
          }

          store.dispatch({ type: 'FATAL_NETWORK_ERROR', message: error });
        } else {
          if (errorAction) {
            store.dispatch({ type: errorAction, data: error.response });
          } else {
            return error.response.data;
          }
        }
      } else {
        if (error.response) {
          return { ...error.response };
        } else {
          return error;
        }
      }
    });
}

export default axiosRequest;
